// Klärungs-Wiedervorlage für Rechnungen: EIN Feld (klaerung_wiedervorlage_am) —
// Default jetzt+7 Tage beim Setzen auf Klärung, per Badge-Picker übersteuerbar.
// Der tägliche Cron (check_klaerung_wiedervorlagen) stellt Fällige auf 'offen'.

export const KLAERUNG_PRESETS: { label: string; tage: number }[] = [
  { label: 'In 7 Tagen', tage: 7 },
  { label: 'In 14 Tagen', tage: 14 },
];

export function klaerungDefaultIso(jetzt: Date): string {
  return new Date(jetzt.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();
}

/** Anzeige fürs Klärung-Badge: „bis TT.MM." — lokale Zeitzone des Betrachters. */
export function formatBis(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n: number) => String(n).padStart(2, '0');
  return `bis ${p(d.getDate())}.${p(d.getMonth() + 1)}.`;
}
